import $ from 'jquery';
import 'select2';

let fieldsAreInitialized = false;

function getNoResultsText() {
  if (window.wp && wp.i18n) {
    return wp.i18n._x(
      'No results matched',
      'Gravity Forms multiselect no results',
      'vtx'
    );
  }

  return 'Aucun résultat correspondant';
}

function initGravityFormsMultiselects() {
  const $multiselects = $(
    '.gform_wrapper select[multiple].gfield_select:not(.no-select2)'
  ).filter(function () {
    return !$(this).closest('.gfield').hasClass('no-select2');
  });

  $multiselects.each(function () {
    const $select = $(this);

    if ($select.hasClass('select2-hidden-accessible')) {
      return;
    }

    $select.select2({
      width: '100%',
      closeOnSelect: false,
      placeholder: $select.data('placeholder') || '',
      language: {
        noResults: getNoResultsText,
      },
    });
  });
}

function changeFileUpload() {
  const multiFileUploads = document.querySelectorAll(
    '.gform_fileupload_multifile'
  );
  if (0 < multiFileUploads.length) {
    multiFileUploads.forEach(function (fileUpload) {
      fileUpload.querySelector('.gform_drop_instructions').textContent =
        wp.i18n._x(
          'Drag and drop file to upload',
          'drag and drop instruction',
          'vtx'
        );
    });
  }
}

$(document).on('gform_post_render', function () {
  fieldsAreInitialized = true;
  initGravityFormsMultiselects();
  changeFileUpload();
});

$(document).on('gform_post_conditional_logic', function () {
  initGravityFormsMultiselects();
});

// ON READY
window.addEventListener('load', function () {
  initGravityFormsMultiselects();

  if (!fieldsAreInitialized) {
    changeFileUpload();
  }
});
